/**
 * 设备的 UUID
 */
export const deviceId = () => {
  return (typeof device === 'undefined') ? '0' : (device.uuid ? device.uuid : '0')
}
/**
 * 设备的用户自定义名称
 */
export const deviceName = () => {
  if (typeof cordova === 'undefined') {
    return 'unknown'
  } else {
    if (typeof cordova.plugins === 'undefined' || typeof cordova.plugins.deviceName === 'undefined') {
      return 'browser'
    } else {
      return (cordova.plugins.deviceName.name ? cordova.plugins.deviceName.name : (device.platform ? device.platform : 'unknown'))
    }
  }
}
/**
 * 二维码扫描
 * ### 权限设置
 * ```
   <edit-config target="NSCameraUsageDescription" file="*-Info.plist" mode="merge">
       <string>用于拍照设为个人头像</string>
   </edit-config>
  ```
 * ### demo
 * ```
   barcodeScan () {
      barcodeScanner( result => {
        alert('We got a barcode\n' +
          'Result: ' + result.text + '\n' +
          'Format: ' + result.format + '\n' +
          'Cancelled: ' + result.cancelled)
      }, err => {
        alert('扫描失败：' + err)
      })
    }
   ```
 */
export const barcodeScanner = (success, failure) => {
  if (typeof cordova === 'undefined') {
    failure('当前环境不支持打开摄像头')
    return
  }
  cordova.plugins.barcodeScanner.scan(
    function (result) {
      success(result)
    },
    function (error) {
      failure(error)
    }, {
      preferFrontCamera: false, // iOS and Android
      showFlipCameraButton: false, // iOS and Android
      showBackButon: true, // Android
      showTorchButton: true, // iOS and Android
      torchOn: false, // Android, launch with the torch switched on (if available)
      saveHistory: true, // Android, save scan history (default false)
      prompt: '将二维码图片放在取景框内即可自动扫描', // Android
      resultDisplayDuration: 500, // Android, display scanned text for X ms. 0 suppresses it entirely, default 1500
      formats: 'QR_CODE,PDF_417', // default: all but PDF_417 and RSS_EXPANDED
      orientation: 'portrait', // Android only (portrait|landscape), default unset so it rotates with the device
      disableAnimations: true, // iOS
      disableSuccessBeep: false // iOS and Android
    }
  )
}
/**
 * 调用摄像头/图片库
 * @param {boolean} isCamera true： 调用摄像头；false： 调用图片库
 * ### 权限设置
 * ```
   <edit-config target="NSCameraUsageDescription" file="*-Info.plist" mode="merge">
       <string>用于拍照设为个人头像</string>
   </edit-config>
   <edit-config target="NSPhotoLibraryUsageDescription" file="*-Info.plist" mode="merge">
       <string>选取照片设为个人头像</string>
   </edit-config>
  ```
 * ### demo
 * ```
   cameraCall (isCamera) {
      getPicture(isCamera, imageData => {
        alert('imageData:', imageData) // img.src = imageData
      }, err => {
        alert('Failed because: ' + err)
      })
    }
   ```
 */
export const getPicture = (isCamera, success, failure) => {
  let sourceType = isCamera ? Camera.PictureSourceType.Camera : Camera.PictureSourceType.PHOTOLIBRARY
  navigator.camera.getPicture(onSuccess, onFailure, {
    quality: 50,
    sourceType: sourceType,
    destinationType: Camera.DestinationType.DATA_URL
  })

  function onSuccess (imageURI) {
    success('data:image/jpeg;base64,' + imageURI)
  }
  function onFailure (error) {
    failure(error)
  }
}

/**
 * 获取当前定位
 * ### 权限设置
 * ```
    <edit-config target="NSLocationWhenInUseUsageDescription" file="*-Info.plist" mode="merge">
        <string>need location access to find things nearby</string>
    </edit-config>
  ```
 * ### demo
 * ```
   currentPositionCall () {
      getCurrentPosition(position => {
        alert('Latitude: '          + position.coords.latitude          + '\n' +
              'Longitude: '         + position.coords.longitude         + '\n' +
              'Altitude: '          + position.coords.altitude          + '\n' +
              'Accuracy: '          + position.coords.accuracy          + '\n' +
              'Altitude Accuracy: ' + position.coords.altitudeAccuracy  + '\n' +
              'Heading: '           + position.coords.heading           + '\n' +
              'Speed: '             + position.coords.speed             + '\n' +
              'Timestamp: '         + position.timestamp                + '\n');
      }, error => {
        alert('code: '    + error.code    + '\n' +
              'message: ' + error.message + '\n');
      })
    }
   ```
 */
export const getCurrentPosition = (success, failure) => {
  navigator.geolocation.getCurrentPosition(onSuccess, onError)

  function onSuccess (position) {
    success(position)
  }
  function onError (error) {
    failure(error)
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/nativeServices.js